<template>
  <div class="signin-container">   

        <span class="md-subheading" style="text-align: center;">Welcome, Please Login ... </span>

        <form autocomplete="off" v-on:submit="signin">
          <md-input-container>
            <label for="email">  E-mail</label>
            <md-input type="text" id="email" v-model="email" required autofocus></md-input>
          </md-input-container>   

          <md-input-container md-has-password>
            <label for="password">  Password</label>
            <md-input type="password" id="password" v-model="password" required></md-input>
          </md-input-container>
          <br/>

        <div style="color:red;" v-if="error">
            <p>There was an error, unable to sign in with those credentials.</p>
        </div>

          <md-layout md-column md-gutter  >
            <md-button class="md-raised md-primary" type="submit" style="color:white;"> <md-icon>input</md-icon> &nbsp; Log In</md-button>
          </md-layout> 
          <br/>

            <md-layout md-gutter md-flex="33" md-flex-offset="33" >
                <md-button class="md-primary"> <md-icon>supervisor_account</md-icon> &nbsp; Register</md-button>
                <md-button class="md-default md-mini"><md-icon>info</md-icon> &nbsp; forgot password</md-button>
             </md-layout> 
        </form>  
  </div>
</template> 
<style lang="scss">
  @import '~vue-material/src/core/stylesheets/variables.scss';

  $sizebar-size: 220px;
 

  .signin-container {  
    display: flex;
    flex-flow: column nowrap; 
    transition: $swift-ease-out;
    padding: 20px;  
    top: 50%;
    position: relative; 
    transform: translateY(-50%);

    @media (min-width: 1281px) { 
      padding-left: $sizebar-size;
      padding-right: $sizebar-size;
    }
  }
 
</style>
<script>
import auth from './../scripts/modules/auth.js';

export default {
  data() {
    return {
      email: null,
      password: null,
      error: false
    };
  },
  methods: {
    signin(event) {
      event.preventDefault();
      auth.signin(this, this.email, this.password);
    }
  }
};
</script>


// WEBPACK FOOTER //
// Signin.vue?68fefc52